import { useKioskConfigStore } from '@/stores/kioskConfig';
import { BreakType } from '@/stores/timesheets';

export function getUnpaidBreakTemplate() {
  const kioskConfig = useKioskConfigStore();

  const breakTemplates =
    kioskConfig.data.KioskAppConfigs.SHIFT_TEMPLATE_SLOTS_CONFIG;

  return breakTemplates[0].SlotValue === BreakType.Unpaid
    ? breakTemplates[0]
    : breakTemplates[1];
}

export function getPaidBreakTemplate() {
  const kioskConfig = useKioskConfigStore();

  const breakTemplates =
    kioskConfig.data.KioskAppConfigs.SHIFT_TEMPLATE_SLOTS_CONFIG;

  return breakTemplates[1].SlotValue === BreakType.Paid
    ? breakTemplates[1]
    : breakTemplates[0];
}
